/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainName } from './DomainName';
import {
    DomainNameFromJSON,
    DomainNameFromJSONTyped,
    DomainNameToJSON,
    DomainNameToJSONTyped,
} from './DomainName';

/**
 * 
 * @export
 * @interface PaginatedDomainNameList
 */
export interface PaginatedDomainNameList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDomainNameList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainNameList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDomainNameList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DomainName>}
     * @memberof PaginatedDomainNameList
     */
    results: Array<DomainName>;
}

/**
 * Check if a given object implements the PaginatedDomainNameList interface.
 */
export function instanceOfPaginatedDomainNameList(value: object): value is PaginatedDomainNameList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDomainNameListFromJSON(json: any): PaginatedDomainNameList {
    return PaginatedDomainNameListFromJSONTyped(json, false);
}

export function PaginatedDomainNameListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDomainNameList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(DomainNameFromJSON)),
    };
}

  export function PaginatedDomainNameListToJSON(json: any): PaginatedDomainNameList {
      return PaginatedDomainNameListToJSONTyped(json, false);
  }

  export function PaginatedDomainNameListToJSONTyped(value?: PaginatedDomainNameList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DomainNameToJSON)),
    };
}

